import React, { useContext } from 'react';

import AppContext from './appContext';
import useAppProvider from './useAppProvider';

const AppProvider: React.FC<{ dashboard: string; MerchantContext?: React.Context<any> }> = ({
	children,
	dashboard,
	MerchantContext
}) => {
	let userMerchant;
	if (MerchantContext) {
		const { merchantName } = useContext(MerchantContext);
		userMerchant = merchantName;
	}
	const { app, onAppChange, showAlert, campaignOptions, setCampaignOptions } = useAppProvider({ dashboard, userMerchant });

	return (
		<AppContext.Provider value={{ app, onAppChange, showAlert, campaignOptions, setCampaignOptions }}>
			{children}
		</AppContext.Provider>
	);
};

export default AppProvider;
